export const WORKER_LOG = 'WORKER_LOG';
export const SEND_ACTION_TO_SPECIFIC_WEBSOCKET_CONNECTION = 'SEND_ACTION_TO_SPECIFIC_WEBSOCKET_CONNECTION';
export const CLIENT_WEBSOCKET_AUTH_ERROR = 'CLIENT_WEBSOCKET_AUTH_ERROR';
export const REPORT_REMOTE_MASTER_STATS = 'REPORT_REMOTE_MASTER_STATS';

export const workerLog = (log = []) => ({
  type: WORKER_LOG,
  payload: {
    log
  }
});

export const sendActionToSpecificWebsocketConenction = ({
  wsId,
  userId,
  action
}) => ({
  type: SEND_ACTION_TO_SPECIFIC_WEBSOCKET_CONNECTION,
  payload: {
    wsId,
    userId,
    action
  }
});

export const clientWebsocketAuthError = ({ error, errorMetaInfo }) => ({
  type: CLIENT_WEBSOCKET_AUTH_ERROR,
  payload: {
    error,
    errorMetaInfo
  }
});

export const reportRemoteMasterStats = ({ stats, ts }) => ({
  type: REPORT_REMOTE_MASTER_STATS,
  payload: {
    stats,
    ts
  }
});
